// extracted by mini-css-extract-plugin
module.exports = {"thin":"container-module--thin--1ASYP","extraThin":"container-module--extra-thin--3hFrm","normal":"container-module--normal--3CH4-","wide":"container-module--wide--XXmHD"};